export default __webpack_public_path__ + "navigation-examples-building-extrusion-thumbnail-v1-480-3350b3fb8eb8dc5ec18db1ed020f7872.webp";